/**
 * Parse a 1-based page-range string ("1,3,5-8") into sorted, de-duplicated
 * 0-based page indices, clamped to [0, pageCount). Whitespace is ignored;
 * malformed tokens are skipped (so partial typing never throws). Reversed
 * ranges ("8-5") are accepted and normalized.
 */
export function parsePageRange(input: string, pageCount: number): number[] {
  if (pageCount <= 0) return [];
  const out = new Set<number>();
  for (const raw of input.split(',')) {
    const token = raw.trim();
    if (token === '') continue;
    const range = /^(\d+)\s*-\s*(\d+)$/.exec(token);
    if (range) {
      let a = Number(range[1]);
      let b = Number(range[2]);
      if (a > b) [a, b] = [b, a];
      for (let n = a; n <= b; n++) addPage(out, n, pageCount);
      continue;
    }
    if (/^\d+$/.test(token)) addPage(out, Number(token), pageCount);
  }
  return [...out].sort((x, y) => x - y);
}

function addPage(out: Set<number>, oneBased: number, pageCount: number): void {
  const idx = oneBased - 1; // 1-based input → 0-based index
  if (idx >= 0 && idx < pageCount) out.add(idx);
}
